/**
 * Copyright IBM Corp. 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
import React from 'react';
import { usePrefix } from '../../internal/usePrefix';

function MenuDivider() {
  var prefix = usePrefix();
  return /*#__PURE__*/React.createElement("li", {
    role: "separator",
    className: "".concat(prefix, "--menu-divider")
  });
}

export default MenuDivider;